import { ProfileViewResponse } from "@/generated-api";
import OnlineIndicator from "./OnlineIndicator";

export default function IndicatorAndName({
  profileView,
}: {
  profileView: ProfileViewResponse;
}) {
  return (
    <div className="flex flex-row items-center gap-2">
      <OnlineIndicator
        lastActiveAt={profileView.last_active_at}
        className="w-3 h-3"
      />
      <span className="text-[1.375rem] md:text-2xl">
        {profileView.display_name}, {profileView.age}
      </span>
    </div>
  );
}
